import { Injectable, inject } from '@angular/core';
import { OmniSearchProvider, OmniSearchService } from '@brighthub/search';
import { AuthService } from '@brightside/core/auth';
import { ClientSearchProvider } from '@brightai/ui';
import { ConversationSearchProvider } from '@brighthub/brightai-conversation-search';
import { EmployeeSearchProvider } from '@brighthub/brightai-employee-search';

@Injectable({
  providedIn: 'root'
})
export class BrightAiOmniSearchRegistry {
  private _auth = inject(AuthService);
  private _search = inject(OmniSearchService);

  async registerProviders() {
    const roles = this._auth.getUserGroups();

    // Lazy import (optional)
    const providers: Array<
      new (...args: any[]) => OmniSearchProvider<any>
    > = [ClientSearchProvider, ConversationSearchProvider, EmployeeSearchProvider];


    for (const P of providers) {
      const instance = inject(P);
      // if (instance.rolesAllowed.some(r => roles.includes(r))) {
        this._search.registerProvider(instance);
      // }
    }
  }
}
